import { render, staticRenderFns } from "./BasicParameters.vue?vue&type=template&id=9453eda0&scoped=true&"
import script from "./BasicParameters.vue?vue&type=script&lang=js&"
export * from "./BasicParameters.vue?vue&type=script&lang=js&"
import style0 from "./BasicParameters.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BasicParameters.vue?vue&type=style&index=1&id=9453eda0&scoped=true&lang=css&"
import style2 from "./BasicParameters.vue?vue&type=style&index=2&media=print_html&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9453eda0",
  null
  
)

export default component.exports